/**
 * @method DomReady
 * @description Dom ready callback, checks for fallbacks to use automatically
 * @param {function} callback method to call on dom ready
 *
 * @see https://stackoverflow.com/questions/3698200/window-onload-vs-document-ready
 * @see https://stackoverflow.com/questions/799981/document-ready-equivalent-without-jquery/55649686#55649686
 */
export const DomReady = function (callback) {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback());
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState !== 'loading') {
        callback();
      }
    });
  }
};

/**
 * @method ZeroPad
 * @description Padds out a number with additional zeros as needed - eg 1 > 001
 * @param {number} num number to pad out
 * @param {number} length number to zeros to pad
 * @returns padded number
 */
export const ZeroPad = (num, length) => {
  const n = Math.abs(num);
  const zeros = Math.max(0, length - Math.floor(n).toString().length);
  let zeroString = Math.pow(10, zeros).toString().substr(1);
  if (num < 0) {
    zeroString = '-' + zeroString;
  }
  return zeroString + n;
};

/**
 * @method ClosestPoint
 * @description Parses an array of points and returns the closes based on supplied x/y
 * @param {number} x x position
 * @param {number} y y position
 * @param {point[]} points an array of points
 * @returns closes point
 */
export const ClosestPoint = (x, y, points) => {
  let minDistance = false;
  let closestPoint;
  for (let a = 0; a < points.length; a++) {
    const distance = Math.sqrt(
      (x - points[a].x) * (x - points[a].x) + (y - points[a].y) * (y - points[a].y)
    );
    if (minDistance === false || distance < minDistance) {
      minDistance = distance;
      closestPoint = points[a];
    }
  }
  return closestPoint;
};
